(function (rootFactory) {
  "use strict";

  if (typeof window !== "undefined" && window.DrSknnCoreReviews) {
    window.DrSknnCoreReviews.initAll(document);
    return;
  }
  var api = rootFactory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (typeof window !== "undefined") window.DrSknnCoreReviews = api;

  if (typeof document !== "undefined") {
    var start = function () { api.initAll(document); };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
    else start();
  }
})(function () {
  "use strict";

  var SCHEMA_VERSION = "drsknn.reviews/1";
  var MODES = ["off", "shadow", "on"];
  var SOURCES = ["google", "pabau"];
  var requestCache = Object.create(null);
  var STOP_WORDS = [
    "about", "and", "area", "areas", "cheshire", "clinic", "consultation", "doctor", "dr",
    "for", "from", "guide", "medical", "option", "options", "result", "results", "service",
    "skin", "sknn", "the", "therapy", "treatment", "treatments", "wilmslow", "with"
  ];
  var BROAD_SINGLE_TERMS = [
    "ageing", "aging", "anti", "area", "body", "face", "facial", "filler", "hair", "injection",
    "ipl", "laser", "led", "line", "remove", "rejuvenation", "scalp", "skin"
  ];
  var TREATMENT_TERMS = [
    "acne treatment", "anti ageing", "anti aging", "anti wrinkle", "botox", "chemical peel",
    "co2", "dermal filler", "dermalux", "exosome", "filler", "hair reduction", "hair removal",
    "hifu", "hydrafacial", "hydrofacial", "ipl", "laser", "led", "mh10", "microneedling",
    "nctf", "onda", "polynucleotide", "prp", "profhilo", "rosacea treatment", "skin booster",
    "thread lift"
  ];

  function clean(value, limit) {
    var text = value == null ? "" : String(value);
    text = text.replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim();
    return limit ? text.slice(0, limit) : text;
  }

  function normaliseText(value) {
    return clean(value).toLowerCase().replace(/&/g, " and ").replace(/[_-]+/g, " ")
      .replace(/[^a-z0-9 ]+/g, " ").replace(/\s+/g, " ").trim();
  }

  function unique(values) {
    var seen = Object.create(null);
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function canonicalToken(value) {
    var token = normaliseText(value);
    var aliases = {
      reductions: "remove", reduction: "remove", removal: "remove", removed: "remove",
      wrinkles: "wrinkle", injections: "injection", fillers: "filler", pigments: "pigment",
      pigmentation: "pigment", cheeks: "cheek", exosomes: "exosome",
      polynucleotides: "polynucleotide"
    };
    return aliases[token] || token;
  }

  function tokens(value) {
    return unique(normaliseText(value).split(" ").map(canonicalToken).filter(function (word) {
      return word.length >= 3 && STOP_WORDS.indexOf(word) === -1;
    }));
  }

  function normaliseTags(raw) {
    var values = [];
    if (Array.isArray(raw)) values = raw;
    else if (raw && typeof raw === "object") {
      ["area_ids", "areas", "category_ids", "categories", "concern_ids", "concerns"].forEach(function (key) {
        var current = raw[key];
        if (Array.isArray(current)) values = values.concat(current);
        else if (typeof current === "string") values = values.concat(current.split(","));
      });
    } else if (typeof raw === "string") values = raw.split(",");
    return unique(values.map(function (value) { return clean(normaliseText(value), 80); }).filter(Boolean)).slice(0, 40);
  }

  function rating(value) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 1 || parsed > 5) return null;
    return Math.round(parsed);
  }

  function averageRating(value) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 1 || parsed > 5) return null;
    return Math.round(parsed * 10) / 10;
  }

  function count(value, fallback) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 0) return Math.max(0, fallback || 0);
    return Math.floor(parsed);
  }

  function validDateTime(value) {
    var text = clean(value, 80);
    return text && Number.isFinite(Date.parse(text)) ? new Date(text).toISOString() : "";
  }

  function safePublicUrl(value) {
    var text = clean(value, 1200);
    if (!/^https:\/\//i.test(text)) return "";
    try {
      var parsed = new URL(text);
      return parsed.protocol === "https:" && !parsed.username && !parsed.password ? parsed.href : "";
    } catch (_error) {
      return "";
    }
  }

  function resolveMode(value, fallback) {
    var candidate = clean(value).toLowerCase();
    if (MODES.indexOf(candidate) !== -1) return candidate;
    var safeFallback = clean(fallback).toLowerCase();
    return MODES.indexOf(safeFallback) !== -1 ? safeFallback : "off";
  }

  function safeGoogleAvatar(value) {
    var url = safePublicUrl(value);
    if (!url) return "";
    var host = new URL(url).hostname;
    return /(^|\.)(googleusercontent\.com|ggpht\.com)$/.test(host) ? url : "";
  }

  function sourceIsValid(source) {
    return SOURCES.indexOf(source) !== -1;
  }

  function normaliseReview(source, raw, index) {
    raw = raw && typeof raw === "object" ? raw : {};
    var reviewRating = rating(raw.rating);
    var text = clean(raw.text || raw.feedback || raw.comment, 1600);
    if (!text || reviewRating === null) return null;

    var fallbackId = source + "-" + index;
    var rawId = raw.id || raw.review_id || raw.reviewId || raw.time || fallbackId;
    return {
      id: clean(rawId, 120) || fallbackId,
      source: source,
      verification: source === "pabau" ? (raw.verification === "verified_appointment" ? "verified_appointment" : "unknown") : "public",
      author: source === "pabau"
        ? (raw.verification === "verified_appointment" ? "Verified patient" : "Patient")
        : (clean(raw.author_name || raw.author || raw.reviewer, 70) || "Google reviewer"),
      rating: reviewRating,
      text: text,
      date: clean(raw.date || raw.relative_time_description || raw.update_time || raw.time, 80),
      service: clean(raw.service, 120),
      category: clean(raw.category, 120),
      tags: normaliseTags(raw.tags),
      author_url: source === "google" ? safePublicUrl(raw.author_url || raw.author_uri) : "",
      author_avatar_url: source === "google" ? safeGoogleAvatar(raw.author_avatar_url || raw.profile_photo_url) : "",
      review_url: source === "google" ? safePublicUrl(raw.review_url || raw.url) : ""
    };
  }

  function normaliseSourcePayload(source, payload, options) {
    if (!sourceIsValid(source)) throw new TypeError("Unsupported review source");
    payload = payload && typeof payload === "object" ? payload : {};
    options = options || {};
    var place = payload.place && typeof payload.place === "object" ? payload.place : {};
    var rawReviews = Array.isArray(payload.reviews)
      ? payload.reviews
      : (Array.isArray(place.reviews) ? place.reviews : []);
    var reviews = rawReviews.map(function (item, index) {
      return normaliseReview(source, item, index);
    }).filter(Boolean);
    var seen = Object.create(null);
    reviews = reviews.filter(function (item) {
      var key = item.source + ":" + item.id;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 100);

    var now = validDateTime(options.now) || new Date().toISOString();
    var generatedAt = validDateTime(payload.generated_at || payload.generatedAt) || now;
    var maxAgeSeconds = Number(options.maxAgeSeconds);
    if (!Number.isFinite(maxAgeSeconds) || maxAgeSeconds < 60) maxAgeSeconds = 86400;
    var staleByAge = Date.parse(now) - Date.parse(generatedAt) > maxAgeSeconds * 1000;
    var rawAverage = payload.average_rating;
    if (rawAverage == null) rawAverage = payload.averageRating;
    if (rawAverage == null) rawAverage = place.rating;
    var rawCount = payload.rating_count;
    if (rawCount == null) rawCount = payload.ratingCount;
    if (rawCount == null) rawCount = payload.totalReviewCount;
    if (rawCount == null) rawCount = payload.total;
    if (rawCount == null) rawCount = payload.total_count;
    if (rawCount == null) rawCount = payload.totalCount;
    if (rawCount == null) rawCount = place.user_rating_count;
    if (rawCount == null) rawCount = place.userRatingCount;
    if (rawCount == null) rawCount = place.user_ratings_total;

    return {
      schema_version: SCHEMA_VERSION,
      generated_at: generatedAt,
      stale: payload.stale === true || staleByAge,
      source: source,
      average_rating: averageRating(rawAverage),
      rating_count: count(rawCount, reviews.length),
      source_url: safePublicUrl(payload.source_url || payload.sourceUrl || place.url || place.googleMapsUri),
      reviews: reviews
    };
  }

  function validateResponse(value) {
    var errors = [];
    if (!value || typeof value !== "object" || Array.isArray(value)) return ["response must be an object"];
    var allowed = ["schema_version", "generated_at", "stale", "source", "average_rating", "rating_count", "source_url", "reviews"];
    Object.keys(value).forEach(function (key) {
      if (allowed.indexOf(key) === -1) errors.push("unexpected response property: " + key);
    });
    if (value.schema_version !== SCHEMA_VERSION) errors.push("invalid schema_version");
    if (!validDateTime(value.generated_at)) errors.push("invalid generated_at");
    if (typeof value.stale !== "boolean") errors.push("stale must be boolean");
    if (!sourceIsValid(value.source)) errors.push("invalid source");
    if (value.average_rating !== null && averageRating(value.average_rating) === null) errors.push("invalid average_rating");
    if (!Number.isInteger(value.rating_count) || value.rating_count < 0) errors.push("invalid rating_count");
    if (value.source_url && !safePublicUrl(value.source_url)) errors.push("invalid source_url");
    if (!Array.isArray(value.reviews) || value.reviews.length > 100) errors.push("invalid reviews collection");
    (Array.isArray(value.reviews) ? value.reviews : []).forEach(function (review, index) {
      if (!review || typeof review !== "object") {
        errors.push("review " + index + " must be an object");
        return;
      }
      if (!clean(review.id, 120)) errors.push("review " + index + " has invalid id");
      if (review.source !== value.source) errors.push("review " + index + " source mismatch");
      if (rating(review.rating) === null) errors.push("review " + index + " has invalid rating");
      if (!clean(review.text, 1600)) errors.push("review " + index + " has invalid text");
      if (!Array.isArray(review.tags)) errors.push("review " + index + " tags must be an array");
    });
    return errors;
  }

  function keywordGroups(value) {
    var values = Array.isArray(value) ? value : String(value || "").split("|");
    return values.map(function (item) {
      var phrase = normaliseText(item);
      return { phrase: phrase, tokens: tokens(phrase) };
    }).filter(function (group) { return group.phrase && group.tokens.length; });
  }

  function matchScore(review, groups) {
    var evidence = normaliseText([review.service, review.category].concat(review.tags || []).join(" "));
    if (!evidence) return 0;
    var evidenceTokens = tokens(evidence);
    var evidenceSet = Object.create(null);
    evidenceTokens.forEach(function (word) { evidenceSet[word] = true; });
    var padded = " " + evidence + " ";
    return groups.reduce(function (best, group) {
      if (group.tokens.length >= 2 && padded.indexOf(" " + group.phrase + " ") !== -1) {
        return Math.max(best, 12 + group.tokens.length);
      }
      var overlap = group.tokens.reduce(function (total, word) {
        return total + (evidenceSet[word] ? 1 : 0);
      }, 0);
      if (group.tokens.length === 1) {
        if (BROAD_SINGLE_TERMS.indexOf(group.tokens[0]) !== -1) return best;
        return overlap === 1 ? Math.max(best, 6) : best;
      }
      var required = Math.max(2, Math.ceil(group.tokens.length * 0.66));
      return overlap >= required ? Math.max(best, overlap * 3) : best;
    }, 0);
  }

  function isGenericClinicReview(review) {
    var text = normaliseText([review.text, review.service, review.category].concat(review.tags || []).join(" "));
    if (!text) return false;
    var padded = " " + text + " ";
    return !TREATMENT_TERMS.some(function (term) {
      return padded.indexOf(" " + term + " ") !== -1;
    });
  }

  function rankReviews(reviews, keywords) {
    var groups = keywordGroups(keywords);
    return (reviews || []).map(function (review, index) {
      return { review: review, index: index, score: matchScore(review, groups) };
    }).filter(function (item) {
      return item.review.text && (!groups.length || item.score > 0 || isGenericClinicReview(item.review));
    }).sort(function (left, right) {
      return right.score - left.score || left.index - right.index;
    });
  }

  function uniqueRanked(items) {
    var seen = Object.create(null);
    return items.filter(function (item) {
      var key = item.review.source + ":" + item.review.id;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function selectReviews(responses, filter, keywords, limit) {
    responses = responses || {};
    filter = ["featured", "google", "pabau"].indexOf(filter) !== -1 ? filter : "featured";
    limit = Math.max(1, Math.min(12, Number(limit) || 3));
    var google = rankReviews((responses.google || {}).reviews || [], keywords);
    var pabau = rankReviews((responses.pabau || {}).reviews || [], keywords);
    if (filter === "google") return google.slice(0, limit);
    if (filter === "pabau") return pabau.slice(0, limit);

    var matchedPabau = pabau.filter(function (item) { return item.score > 0; });
    var matchedGoogle = google.filter(function (item) { return item.score > 0; });
    var generalPabau = pabau.filter(function (item) { return item.score === 0; });
    var generalGoogle = google.filter(function (item) { return item.score === 0; });
    var featured = [];
    if (matchedPabau[0] || generalPabau[0]) featured.push(matchedPabau[0] || generalPabau[0]);
    if (matchedGoogle[0] || generalGoogle[0]) featured.push(matchedGoogle[0] || generalGoogle[0]);
    if (matchedPabau[1] || generalPabau[1]) featured.push(matchedPabau[1] || generalPabau[1]);
    return uniqueRanked(featured.concat(matchedPabau, matchedGoogle, generalPabau, generalGoogle)).slice(0, limit);
  }

  function endpointUrl(value, baseUrl, allowedOrigins) {
    var text = clean(value, 1600);
    if (!text) return "";
    try {
      var parsed = new URL(text, baseUrl);
      var base = new URL(baseUrl);
      if (parsed.username || parsed.password) return "";
      if (parsed.origin === base.origin && (parsed.protocol === "https:" || parsed.protocol === "http:")) return parsed.href;
      if (parsed.protocol !== "https:") return "";
      return allowedOrigins.indexOf(parsed.origin) !== -1 ? parsed.href : "";
    } catch (_error) {
      return "";
    }
  }

  function fetchJson(url, timeout, fetcher) {
    fetcher = fetcher || (typeof window !== "undefined" ? window.fetch.bind(window) : null);
    if (!fetcher || !url) return Promise.reject(new Error("Review endpoint unavailable"));
    var cacheKey = url;
    if (requestCache[cacheKey]) return requestCache[cacheKey];
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer;
    var timeoutPromise = new Promise(function (_resolve, reject) {
      timer = setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error("Review endpoint timeout"));
      }, timeout);
    });
    var request = fetcher(url, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      cache: "no-store",
      headers: { Accept: "application/json" },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response || !response.ok) throw new Error("Review endpoint failed");
      return response.json();
    });
    requestCache[cacheKey] = Promise.race([request, timeoutPromise]).then(function (payload) {
      clearTimeout(timer);
      delete requestCache[cacheKey];
      if (!payload || payload.ok === false) throw new Error("Review source unavailable");
      return payload;
    }, function (error) {
      clearTimeout(timer);
      delete requestCache[cacheKey];
      throw error;
    });
    return requestCache[cacheKey];
  }

  function appendText(parent, tagName, className, value) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = value;
    parent.appendChild(element);
    return element;
  }

  function createCard(item, googleLogo) {
    var review = item.review;
    var matched = item.score > 0;
    var card = document.createElement("article");
    card.className = "drsknn-core-reviews__card";
    card.setAttribute("data-drsknn-core-review-card", "");

    var source = document.createElement("div");
    source.className = "drsknn-core-reviews__card-source";
    appendText(source, "span", "", review.source === "pabau" ? (review.verification === "verified_appointment" ? "Pabau · verified appointment" : "Pabau · patient feedback") : "Google · public review");
    var stars = appendText(source, "span", "drsknn-core-reviews__stars", new Array(review.rating + 1).join("★") + new Array(6 - review.rating).join("☆"));
    stars.setAttribute("aria-label", review.rating + " out of 5 stars");
    card.appendChild(source);

    if (matched) appendText(card, "h3", "", review.service || "Relevant patient feedback");
    var quote = document.createElement("blockquote");
    appendText(quote, "p", "", review.text);
    card.appendChild(quote);

    {
      var expand = appendText(card, "button", "drsknn-core-reviews__expand", "Read full review");
      expand.type = "button";
      expand.hidden = true;
      expand.setAttribute("aria-label", "Read full review by " + review.author);
      expand.setAttribute("aria-expanded", "false");
      expand.addEventListener("click", function () {
        var expanded = card.classList.toggle("is-expanded");
        expand.setAttribute("aria-expanded", expanded ? "true" : "false");
        expand.textContent = expanded ? "Show less" : "Read full review";
        expand.setAttribute("aria-label", (expanded ? "Collapse review by " : "Read full review by ") + review.author);
      });
    }

    var footer = document.createElement("footer");
    if (review.source === "google" && review.author_avatar_url) {
      var avatar = document.createElement("img");
      avatar.src = review.author_avatar_url;
      avatar.alt = review.author;
      avatar.className = "drsknn-core-reviews__avatar";
      avatar.width = 40; avatar.height = 40;
      avatar.loading = "lazy"; avatar.referrerPolicy = "no-referrer";
      footer.appendChild(avatar);
    }
    var author = appendText(footer, review.author_url ? "a" : "strong", "drsknn-core-reviews__author", review.author);
    if (review.author_url) {
      author.href = review.author_url;
      author.target = "_blank";
      author.rel = "noopener noreferrer";
    }
    if (review.review_url) {
      var original = appendText(footer, "a", "", "Read original review");
      original.href = review.review_url;
      original.target = "_blank";
      original.rel = "noopener noreferrer";
    }
    if (matched) appendText(footer, "span", "", review.service || "Feedback matched to this treatment route");
    if (review.source === "google") {
      var attribution = document.createElement("div");
      attribution.className = "drsknn-core-reviews__google-attribution";
      attribution.setAttribute("translate", "no");
      if (googleLogo) {
        var logo = document.createElement("img");
        logo.src = googleLogo; logo.alt = "Google Maps"; logo.height = 18;
        attribution.appendChild(logo);
      } else attribution.textContent = "Google Maps";
      footer.appendChild(attribution);
    }
    card.appendChild(footer);
    return card;
  }

  function parseAllowedOrigins(element, baseUrl) {
    var values = clean(element.getAttribute("data-allowed-origins"), 2000).split(",").map(function (item) {
      try { return new URL(item.trim(), baseUrl).origin; } catch (_error) { return ""; }
    }).filter(Boolean);
    return unique(values);
  }

  var googleBrowserRequest = null;
  function fetchBrowserGoogleReviews() {
    if (googleBrowserRequest) return googleBrowserRequest;
    googleBrowserRequest = new Promise(function (resolve, reject) {
      if (typeof window === "undefined" || typeof document === "undefined") { reject(new Error("Browser reviews unavailable")); return; }
      var complete = false, started = false;
      var timer = window.setTimeout(function () { finish(new Error("Google reviews timed out")); }, 12000);
      function finish(error, value) {
        if (complete) return;
        complete = true;
        window.clearTimeout(timer);
        if (error) reject(error); else resolve(value);
      }
      function readPlace() {
        if (started || complete) return;
        started = true;
        try {
          var service = new window.google.maps.places.PlacesService(document.createElement("div"));
          service.getDetails({ placeId: "ChIJ-7JdE7NNekgRpxOzXg2xuUo", fields: ["name", "rating", "user_ratings_total", "reviews", "url"] }, function (place, status) {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place || !Array.isArray(place.reviews)) { finish(new Error("Google review source unavailable")); return; }
            finish(null, { ok: true, place: place, reviews: place.reviews, source: "google_places_browser" });
          });
        } catch (error) { finish(error); }
      }
      if (window.google && window.google.maps && window.google.maps.places) { readPlace(); return; }
      var script = document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]');
      if (script) {
        script.addEventListener("load", readPlace, { once: true });
        script.addEventListener("error", function () { finish(new Error("Google reviews unavailable")); }, { once: true });
      } else {
        script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDCX6AgsjLisxjIle7tYdxVhTQI0V5aXQI&libraries=places&v=weekly&loading=async";
        script.async = true;
        script.onload = readPlace;
        script.onerror = function () { finish(new Error("Google reviews unavailable")); };
        document.head.appendChild(script);
      }
    }).catch(function (error) { googleBrowserRequest = null; throw error; });
    return googleBrowserRequest;
  }

  function emitState(element, state, detail) {
    element.setAttribute("data-reviews-state", state);
    if (typeof CustomEvent === "function") {
      element.dispatchEvent(new CustomEvent("drsknn-core:reviews-state", {
        bubbles: true,
        detail: {
          instanceId: element.getAttribute("data-instance-id") || "",
          state: state,
          sourceCount: detail && detail.sourceCount || 0,
          reviewCount: detail && detail.reviewCount || 0
        }
      }));
    }
  }

  function init(element, options) {
    options = options || {};
    if (!element || element.getAttribute("data-drsknn-core-reviews-ready") === "true") return null;
    var mode = resolveMode(element.getAttribute("data-feature-mode"), "off");
    element.setAttribute("data-drsknn-core-reviews-ready", "true");
    if (mode === "off") {
      emitState(element, "off");
      return null;
    }

    var track = element.querySelector("[data-reviews-track]");
    var status = element.querySelector("[data-reviews-status]");
    if (!track || !status) {
      emitState(element, "invalid");
      return null;
    }
    var baseUrl = options.baseUrl || (typeof document !== "undefined" ? document.baseURI : "https://drsknn.com/");
    var allowedOrigins = parseAllowedOrigins(element, baseUrl);
    var timeout = Math.max(1000, Math.min(30000, Number(element.getAttribute("data-timeout-ms")) || 9000));
    var maxAge = Math.max(60, Number(element.getAttribute("data-max-age-seconds")) || 86400);
    var limit = Math.max(1, Math.min(12, Number(element.getAttribute("data-review-limit")) || 3));
    var keywords = element.getAttribute("data-review-keywords") || "";
    var buttons = Array.prototype.slice.call(element.querySelectorAll("[data-review-filter]"));
    var previous = element.querySelector("[data-reviews-prev]");
    var next = element.querySelector("[data-reviews-next]");
    var googleSummary = element.querySelector("[data-review-google-summary]");
    var pabauSummary = element.querySelector("[data-review-pabau-summary]");
    var googleLink = element.querySelector("[data-review-google-link]");
    var navigation = element.querySelector("[data-reviews-navigation]");
    var position = element.querySelector("[data-reviews-position]");
    var retry = element.querySelector("[data-reviews-retry]");
    var googleOnly = element.getAttribute("data-review-sources") === "google";
    var state = { filter: "featured", loading: false, loaded: false, responses: {}, errors: {} };

    function sourceUrl(name, attribute) {
      var result = endpointUrl(element.getAttribute(attribute), baseUrl, allowedOrigins);
      if (!result) state.errors[name] = "blocked_or_missing_endpoint";
      return result;
    }

    function updateArrows() {
      if (!previous || !next) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll("[data-drsknn-core-review-card]"));
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      var overflow = maximum > 3;
      previous.hidden = !overflow;
      next.hidden = !overflow;
      previous.disabled = !overflow || track.scrollLeft <= 3;
      next.disabled = !overflow || track.scrollLeft >= maximum - 3;
      if (navigation) navigation.hidden = !cards.length;
      if (position && cards.length) {
        var bounds = track.getBoundingClientRect();
        var visible = cards.map(function (card, index) { var box = card.getBoundingClientRect(); return box.left < bounds.right - 24 && box.right > bounds.left + 24 ? index + 1 : 0; }).filter(Boolean);
        var first = visible[0] || 1, last = visible[visible.length - 1] || first;
        position.textContent = (first === last ? "Review " + first : "Reviews " + first + "–" + last) + " of " + cards.length;
      }
    }

    function updateLayout() {
      Array.prototype.forEach.call(track.querySelectorAll("[data-drsknn-core-review-card]"), function (card) {
        var text = card.querySelector("blockquote p");
        var expand = card.querySelector(".drsknn-core-reviews__expand");
        if (text && expand) expand.hidden = !card.classList.contains("is-expanded") && text.scrollHeight <= text.clientHeight + 1;
      });
      updateArrows();
    }

    function updateSummary(name, node) {
      if (!node) return;
      var response = state.responses[name];
      if (!response) {
        node.textContent = name === "pabau" ? "Patient feedback" : "Public patient reviews";
        return;
      }
      var prefix = response.stale ? "Cached · " : "";
      if (name === "google") {
        var score = response.average_rating ? response.average_rating.toFixed(1) + " from " : "";
        node.replaceChildren();
        if (response.average_rating) {
          appendText(node, "span", "drsknn-core-reviews__rating", response.average_rating.toFixed(1));
          appendText(node, "span", "drsknn-core-reviews__rating-scale", " / 5");
        }
        appendText(node, "span", "drsknn-core-reviews__rating-count", response.rating_count ? prefix + "Based on " + response.rating_count + " Google ratings" : prefix + "Public patient reviews");
      } else {
        node.textContent = response.rating_count ? prefix + response.rating_count + " patient reviews" : prefix + "Patient feedback";
      }
    }

    function render() {
      var items = selectReviews(state.responses, state.filter, keywords, limit);
      track.replaceChildren();
      if (!items.length) {
        appendText(track, "div", "drsknn-core-reviews__empty", "Current review text is temporarily unavailable. Use the independent source links to read patient feedback.");
      } else {
        items.forEach(function (item) { track.appendChild(createCard(item, element.getAttribute("data-google-attribution-logo"))); });
      }
      track.scrollLeft = 0;
      buttons.forEach(function (button) {
        var filter = button.getAttribute("data-review-filter") || "featured";
        button.setAttribute("aria-pressed", filter === state.filter ? "true" : "false");
        if (filter === "google" || filter === "pabau") button.disabled = !state.responses[filter];
      });
      updateSummary("google", googleSummary);
      updateSummary("pabau", pabauSummary);
      if (googleLink && state.responses.google && state.responses.google.source_url) googleLink.href = state.responses.google.source_url;
      var sourceCount = Object.keys(state.responses).length;
      var rawReviewCount = Object.keys(state.responses).reduce(function (total, source) {
        return total + state.responses[source].reviews.length;
      }, 0);
      var stale = Object.keys(state.responses).some(function (source) { return state.responses[source].stale; });
      if (!sourceCount) status.textContent = "Review feeds are temporarily unavailable. Use the independent source links to read current feedback.";
      else if (stale) status.textContent = "Showing " + items.length + " cached patient reviews while a source refresh is pending.";
      else if (googleOnly) status.textContent = "A selection of " + items.length + " reviews from Google Maps.";
      else if (sourceCount === 1) status.textContent = "Showing " + items.length + " patient reviews from the available source.";
      else status.textContent = "Showing " + items.length + " patient reviews. Treatment-linked feedback is prioritised only where the source supports it.";
      emitState(element, sourceCount ? (stale ? "stale" : "ready") : "empty", { sourceCount: sourceCount, reviewCount: rawReviewCount });
      if (retry) { retry.hidden = !!items.length; retry.disabled = false; }
      track.removeAttribute("aria-busy");
      if (typeof requestAnimationFrame === "function") requestAnimationFrame(updateLayout);
      else updateLayout();
    }

    function fetchSource(name, url) {
      if (!url) return Promise.resolve(null);
      return fetchJson(url, timeout, options.fetcher).catch(function (error) {
        if (name === "google" && !options.fetcher) return fetchBrowserGoogleReviews();
        throw error;
      }).then(function (payload) {
        var response = normaliseSourcePayload(name, payload, { maxAgeSeconds: maxAge });
        var errors = validateResponse(response);
        if (errors.length) throw new Error("Invalid review response: " + errors.join("; "));
        state.responses[name] = response;
        return response;
      }).catch(function (error) {
        state.errors[name] = clean(error && error.message, 180) || "request_failed";
        return null;
      });
    }

    function load() {
      if (state.loading || state.loaded) return Promise.resolve(state.responses);
      state.loading = true;
      track.setAttribute("aria-busy", "true");
      if (retry) retry.disabled = true;
      status.textContent = "Loading current patient reviews…";
      emitState(element, "loading");
      var google = sourceUrl("google", "data-google-reviews-url");
      var googleFallback = sourceUrl("google_fallback", "data-google-reviews-fallback-url");
      var pabau = sourceUrl("pabau", "data-pabau-reviews-url");
      var googleRequest = fetchSource("google", google).then(function (response) {
        if (response || !googleFallback) return response;
        return fetchSource("google", googleFallback);
      });
      return Promise.all([googleRequest, fetchSource("pabau", pabau)]).then(function () {
        state.loading = false;
        state.loaded = true;
        render();
        return state.responses;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        state.filter = button.getAttribute("data-review-filter") || "featured";
        if (!state.loaded) load();
        else render();
      });
    });
    if (retry) retry.addEventListener("click", function () {
      state.loaded = false;
      state.errors = {};
      load();
    });
    function move(direction) {
      var first = track.querySelector("[data-drsknn-core-review-card]");
      var gap = typeof window !== "undefined" ? parseFloat(window.getComputedStyle(track).gap) || 0 : 0;
      var distance = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
      var reduceMotion = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      track.scrollBy({ left: direction * distance, behavior: reduceMotion ? "auto" : "smooth" });
    }
    if (previous) previous.addEventListener("click", function () {
      move(-1);
    });
    if (next) next.addEventListener("click", function () {
      move(1);
    });
    track.addEventListener("scroll", updateArrows, { passive: true });
    track.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      move(event.key === "ArrowRight" ? 1 : -1);
    });
    if (typeof window !== "undefined") window.addEventListener("resize", updateLayout, { passive: true });
    if (typeof ResizeObserver === "function") new ResizeObserver(updateLayout).observe(track);
    if (typeof document !== "undefined" && document.fonts && document.fonts.ready) document.fonts.ready.then(updateLayout);

    if (mode === "shadow") load();
    else if (typeof IntersectionObserver === "function") {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        load();
      }, { rootMargin: "600px 0px" });
      observer.observe(element);
    } else setTimeout(load, 500);

    return { load: load, state: state, render: render };
  }

  function initAll(scope, options) {
    scope = scope || document;
    var elements = [];
    if (scope.matches && scope.matches("[data-drsknn-core-reviews]")) elements.push(scope);
    elements = elements.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-drsknn-core-reviews]")));
    return elements.map(function (element) { return init(element, options); }).filter(Boolean);
  }

  return {
    SCHEMA_VERSION: SCHEMA_VERSION,
    MODES: MODES.slice(),
    resolveMode: resolveMode,
    normaliseSourcePayload: normaliseSourcePayload,
    validateResponse: validateResponse,
    rankReviews: rankReviews,
    selectReviews: selectReviews,
    endpointUrl: endpointUrl,
    init: init,
    initAll: initAll,
    _test: {
      clean: clean,
      safePublicUrl: safePublicUrl,
      normaliseTags: normaliseTags,
      matchScore: matchScore,
      isGenericClinicReview: isGenericClinicReview,
      resetRequestCache: function () { requestCache = Object.create(null); }
    }
  };
});
